import * as React from 'react';

import {Illustration} from '../../illustrations/illustration';
import {StackLegacy} from '../../layout/stack/stack-legacy';

type Props = {
    imageSrc?: string;
    text: string;
};

export function EmptyState(props: Props) {
    const imageSrc = props.imageSrc || 'cactus-empty-state';

    return (
        <div className='flex text-align-center justify-center align-center full-width mt-64 pad-16 border-box'>
            <StackLegacy spacing={16}>
                <Illustration src={imageSrc} width={120} />
                {props.text}
            </StackLegacy>
        </div>
    );
}
